module.exports = __webpack_public_path__ + "first-5_uv.jpg?2c94a47990d5c708b9e20d81b416395d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-5_uv.jpg
// module id = 591
// module chunks = 0